<template>
  <div class="container">
    <div class="row map-list-item route" @click="itemClicked" :title="this.entryData.nimi">
      <div class='col-1 id'>{{ this.entryData.linja }}</div> 
      <div class='col name'>{{ this.nimi }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapRouteEntry',
  props: {
   entry: {type: Object}
  },
  data: function() {
    return {
      entryData: null,
      defaultData: {tunnus:"-", nimi:"-"}
    }
  },
  created() {
    this.entryData = Object.assign(this.defaultData,this.entry);
    //debugger;
  },
  computed: {
    nimi: function() {
      //return this.entryData.nimi + " " + this.suunta;
      /*
      if(this.entryData.nimi.length <= 30) {
        return this.entryData.nimi;
      } else {
        return this.entryData.nimi.substring(0,30) + "...";
      }
      */

      return this.entryData.nimi
    },
    suunta: function() {
      try {
        return this.entryData.destinations[0].nimi;
      } catch(err) {
        return "";
      }
    },
    tunnus: function() {
      return this.entryData.tunnus.substring(0,8);
    }
  },
  methods: {
    itemClicked() {
      this.$emit('click', this.entryData.tunnus);
    }
  }
}
</script>


<style scoped lang="scss">

  div[class="col-1 id"] {
    font-size: 0.8em;
}


  div[class="col name"] {
    font-size: 0.8em;
}
</style>